/* global axios */
import ApiClient from './ApiClient';

/**
 * REST client for the deals. Plain account-scoped CRUD, with one extra verb:
 * stage movement is its own command server-side (it owns the won/lost
 * bookkeeping and the customer promotion), so it is its own request rather than
 * a PATCH of `pipeline_stage_id`.
 */
class OpportunitiesAPI extends ApiClient {
  constructor() {
    super('opportunities', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  changeStage(id, pipelineStageId) {
    return axios.post(`${this.url}/${id}/change_stage`, {
      pipeline_stage_id: pipelineStageId,
    });
  }
}

export default new OpportunitiesAPI();
